<template>
    <el-dialog
          title="提示"
          :visible.sync="show2"
          width="26%"
          top="29vh"
          center
      >
        <img v-if="companyInfo.weChatPublicAccount" :src="companyInfo.weChatPublicAccount" style="display:block;width: 300px;height: 300px;margin:10px auto" alt="">
        <div style="font-weight: bold;text-align: center;font-size: 16px;margin-top:10px">PC端暂未开通此服务,请前往我司微信公众号办理!</div>
        <span slot="footer"  class="dialog-footer">
          <el-button type="primary" @click="show2=false">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import companyInfo from '../config.js'
console.log('weChatPublicAccount',companyInfo.weChatPublicAccount)
  export default {
    name: 'dialogWechat',
    data(){
      return {
        companyInfo,
        show2:false
      }
    },
    props: {
      show: {
        type: Boolean,
        default: false
    },
  },
  watch:{
    show(n){
      console.log(n)
      this.show2 = n
    },
    show2(n){
      if(!n){
        this.$emit('close')
      }
    }
  },
}
</script>
